module.exports = __webpack_public_path__ + "static/media/world-tour.d5cc8247.jpg";